import axios from 'axios';
import { API_BASE_URL as BASE_URL } from '../../config/api';

const API_BASE_URL = `${BASE_URL}/api/v1/admin`;

// 멤버 관리
export const getAllMembers = async (page = 0, size = 20) => {
    const response = await axios.get(`${API_BASE_URL}/members`, {
        params: { page, size }
    });
    return response.data;
};

export const searchMembers = async (page = 0, size = 20, q, field) => {
    const response = await axios.get(`${API_BASE_URL}/members/search`, {
        params: { page, size, q, field }
    });
    return response.data;
};

export const getMember = async (memberId) => {
    const response = await axios.get(`${API_BASE_URL}/members/${memberId}`);
    return response.data;
};

export const getMemberImageUrl = async (memberId) => {
    const response = await axios.get(`${API_BASE_URL}/members/${memberId}/image-url`);
    return response.data;
};

export const resetMemberPassword = async (memberId, newPassword) => {
    await axios.patch(`${API_BASE_URL}/members/${memberId}/password`, {
        newPassword: newPassword
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

export const changeMemberStatus = async (memberId, status) => {
    await axios.patch(`${API_BASE_URL}/members/${memberId}/status`, {
        status: status
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

export const changeMemberPoint = async (memberId, point) => {
    await axios.patch(`${API_BASE_URL}/members/${memberId}/points`, {
        point: point
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

export const hardDeleteMember = async (memberId) => {
    await axios.delete(`${API_BASE_URL}/members/${memberId}`);
};

// 신고 관리
export const getAllReports = async (page = 0, size = 20) => {
    const response = await axios.get(`${API_BASE_URL}/reports`, {
        params: { page, size }
    });
    return response.data;
};

export const deleteReport = async (reportId) => {
    await axios.delete(`${API_BASE_URL}/reports/${reportId}`);
};

// 모임 관리
export const getAllMeetings = async (page = 0, size = 20) => {
    const response = await axios.get(`${API_BASE_URL}/meetings`, {
        params: { page, size }
    });
    return response.data;
};

export const searchMeetings = async (page = 0, size = 20, q, field) => {
    const response = await axios.get(`${API_BASE_URL}/meetings/search`, {
        params: { page, size, q, field }
    });
    return response.data;
};

export const getMemberListOnMeeting = async (meetingId) => {
    const response = await axios.get(`${API_BASE_URL}/meetings/${meetingId}/members`);
    return response.data;
};

export const getChatListOnMeeting = async (meetingId) => {
    const response = await axios.get(`${API_BASE_URL}/meetings/${meetingId}/chats`);
    return response.data;
};

export const getMeetingImageUrl = async (meetingId) => {
    const response = await axios.get(`${API_BASE_URL}/meetings/${meetingId}/image-url`);
    return response.data;
};

export const changeMeetingStatus = async (meetingId, status) => {
    await axios.patch(`${API_BASE_URL}/meetings/${meetingId}`, {
        status: status
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

export const hardDeleteMeeting = async (meetingId) => {
    await axios.delete(`${API_BASE_URL}/meetings/${meetingId}`);
};

// 공지사항 관리
export const getAllAnnouncements = async (page = 0, size = 20) => {
    const response = await axios.get(`${API_BASE_URL}/announcements`, {
        params: { page, size }
    });
    return response.data;
};

export const createAnnouncement = async (title, content) => {
    await axios.post(`${API_BASE_URL}/announcements`, {
        title: title,
        content: content
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

export const updateAnnouncement = async (announcementId, title, content) => {
    await axios.patch(`${API_BASE_URL}/announcements/${announcementId}`, {
        title: title,
        content: content
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

export const deleteAnnouncement = async (announcementId) => {
    await axios.delete(`${API_BASE_URL}/announcements/${announcementId}`);
};

// 이벤트 관리
export const getAllEvents = async (page = 0, size = 20) => {
    const response = await axios.get(`${API_BASE_URL}/events`, {
        params: { page, size }
    });
    return response.data;
};

export const getEventAdmin = async (eventId) => {
    const response = await axios.get(`${API_BASE_URL}/events/${eventId}`);
    return response.data;
};

export const createEvent = async (title, content, imageId) => {
    await axios.post(`${API_BASE_URL}/events`, {
        title: title,
        content: content,
        imageId: imageId
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

export const updateEvent = async (eventId, title, content, imageId) => {
    await axios.patch(`${API_BASE_URL}/events/${eventId}`, {
        title: title,
        content: content,
        imageId: imageId
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

export const deleteEvent = async (eventId) => {
    await axios.delete(`${API_BASE_URL}/events/${eventId}`);
};

// 제휴매장 신청 관리
export const getAllPartnerPlaceApplications = async (page = 0, size = 20) => {
    const response = await axios.get(`${API_BASE_URL}/partner-place-applications`, {
        params: { page, size }
    });
    return response.data;
};

export const acceptPartnerPlaceApplication = async (partnerPlaceApplicationId) => {
    await axios.patch(`${API_BASE_URL}/partner-place-applications/${partnerPlaceApplicationId}`, {}, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

export const deletePartnerPlaceApplication = async (partnerPlaceApplicationId) => {
    await axios.delete(`${API_BASE_URL}/partner-place-applications/${partnerPlaceApplicationId}`);
};

// 제휴매장 관리
export const getAllPartnerPlaces = async (page = 0, size = 20) => {
    const response = await axios.get(`${API_BASE_URL}/partner-place`, {
        params: { page, size }
    });
    return response.data;
};

export const searchPartnerPlaces = async (page = 0, size = 20, q, field) => {
    const response = await axios.get(`${API_BASE_URL}/partner-place/search`, {
        params: { page, size, q, field }
    });
    return response.data;
};

export const updatePartnerPlaceCache = async (partnerPlaceId, cache) => {
    await axios.patch(`${API_BASE_URL}/partner-place/${partnerPlaceId}/cache`, {
        cache: cache
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

export const updatePartnerPlaceUntil = async (partnerPlaceId, until) => {
    await axios.patch(`${API_BASE_URL}/partner-place/${partnerPlaceId}/until`, {
        until: until
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

export const updatePartnerPlaceUntilPlusMonth = async (partnerPlaceId) => {
    await axios.patch(`${API_BASE_URL}/partner-place/${partnerPlaceId}/until/plusmonth`, {}, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

export const updatePartnerPlace = async (partnerPlaceId, updateData) => {
    await axios.patch(`${API_BASE_URL}/partner-place/${partnerPlaceId}`, updateData, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

export const deletePartnerPlace = async (partnerPlaceId) => {
    await axios.delete(`${API_BASE_URL}/partner-place/${partnerPlaceId}`);
};

// 알림 발송
export const sendNotificationForMember = async (memberId, title, content, url) => {
    await axios.post(`${API_BASE_URL}/members/notifications/${memberId}`, {
        title: title,
        content: content,
        url: url
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

export const sendNotificationForAllMembers = async (title, content, url) => {
    await axios.post(`${API_BASE_URL}/members/notifications/all`, {
        memberId: null,
        title: title,
        content: content,
        url: url
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 어드민 보안코드 변경
export const changeSecurityCode = async (securityCode) => {
    await axios.patch(`${API_BASE_URL}/dashboard/security-code`, securityCode, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}; 


/**

@Operation(summary = "전체 결제 페이지네이션 조회", description = "전체 결제의 모든 필드를 페이지네이션해서 조회합니다.")
@GetMapping("/payments")
public ResponseEntity<PaginatedResponse<Payment>> getAllPayments(
        @RequestParam(defaultValue = "0") int page,
        @RequestParam(defaultValue = "20") int size
) {
    PaginatedResponse<Payment> response = paymentService.findAllPaymentListWithPagination(page, size);
    return ResponseEntity.status(HttpStatus.OK).body(response);
}

@Operation(summary = "결제 검색", description = "id, member_id 로 결제를 페이지네이션해서 조회합니다.")
@GetMapping("/payments/search")
public ResponseEntity<PaginatedResponse<Payment>> searchPayments(
        @RequestParam(defaultValue = "0") int page,
        @RequestParam(defaultValue = "20") int size,
        @RequestParam String q,
        @RequestParam String field
) {
    PaginatedResponse<Payment> response = paymentService.searchPaymentsWithPagination(page, size, q, field);
    return ResponseEntity.status(HttpStatus.OK).body(response);
}

 * 
 */

// 결제 관리
export const getAllPayments = async (page = 0, size = 20) => {
    const response = await axios.get(`${API_BASE_URL}/payments`, {
        params: { page, size }
    });
    return response.data;
};

export const searchPayments = async (page = 0, size = 20, q, field) => {
    const response = await axios.get(`${API_BASE_URL}/payments/search`, {
        params: { page, size, q, field }
    });
    return response.data;
};

// 쌀 트랜잭션 관련 API
export const getAllRiceTransactions = async (page = 0, size = 20) => {
    const response = await axios.get(`${API_BASE_URL}/rice-transactions`, {
        params: { page, size }
    });
    return response.data;
};

export const searchRiceTransactions = async (page = 0, size = 20, query, field) => {
    const response = await axios.get(`${API_BASE_URL}/rice-transactions/search`, {
        params: { page, size, q: query, field }
    });
    return response.data;
};

// 쌀 지급/회수 관련 API
export const grantRice = async (memberId, amount) => {
    const response = await axios.patch(`${API_BASE_URL}/rice-transactions/grant`, {
        memberId,
        amount
    });
    return response.data;
};

export const grantRiceForAll = async (amount) => {
    const response = await axios.patch(`${API_BASE_URL}/rice-transactions/grant-all`, {
        amount
    });
    return response.data;
};

export const revokeRice = async (memberId, amount) => {
    const response = await axios.patch(`${API_BASE_URL}/rice-transactions/revoke`, {
        memberId,
        amount
    });
    return response.data;
};

export const syncRiceTransactions = async () => {
    const response = await axios.post(`${API_BASE_URL}/rice-transactions/sync`);
    return response.data;
};